module.exports = {
  strings: {
    generatingThumbnails: 'Generating thumbnails...'
  }
};